const illustration = document.getElementById('scalabor-illustration');

function addLabelToCursor(){

    // create label
    let label = document.createElement('div');

    // add class
    label.classList.add('label');
    label.classList.add('label--dark');

    // add id
    label.id = 'cursor-label';

    // add text 
    label.innerHTML = 'Klik om te bekijken';

    // add label to illustration
    illustration.appendChild(label);

    // let label follow cursor   
    document.addEventListener('mousemove', function(e) {

        let left = e.offsetX;
        let top = e.offsetY + 16;

        // position label in center of cursor
        left = left - (label.offsetWidth / 2);

        label.style.left = left + 'px';
        label.style.top = top + 'px';

    });

}


let timeoutHandle;

function showCursorLabel(item){

    let itemId = item.id;
    let title = itemId + '_title';

    // get const by labelHref
    title = eval(title);

    if(title && title.length > 0) {
        // add title to label
        document.getElementById('cursor-label').innerHTML = title;

        const cursorLabel = document.getElementById('cursor-label');
        cursorLabel.classList.add('active');

        clearTimeout(timeoutHandle);
    }

}


function hideCursorLabel(){

    timeoutHandle = setTimeout(function () {
        const cursorLabel = document.getElementById('cursor-label');
        cursorLabel.classList.remove('active');
    }, 500);

}


function loopIllustrations(){

    const illustrationArray = [broodtrommel, ecommerce, fietsenmaker, fietspomp, horeca, plantsoen, postfiets, schoonmaak, zonnepanelen, zorg, bloemen, kas, fietsen, dak];
    const cursorLabel = document.getElementById('cursor-label');

    // loop through array and create a label for each item
    illustrationArray.forEach(function(item){

        // get id
        let itemId = item.id;

        // get label by data-id
        let labelHref = itemId + '_url';
        
        // add label click event
        if(eval(labelHref)) {

            // get const by labelHref
            labelHref = eval(labelHref);

            // add cursor pointer 
            item.style.cursor = 'pointer';

            // on click 
            item.addEventListener('click', function(){

                // labelHref in new tab 
                window.open(labelHref, '_blank');

            });

        }

        // add label hover event
        item.addEventListener('mouseover', function(){
                
            showCursorLabel(item);

        });

        // on mouse out
        item.addEventListener('mouseleave', function(){

            hideCursorLabel();

        });
 
    });

}

// on page load 
window.onload = function(){

    if(illustration){
        addLabelToCursor();
        loopIllustrations();
    }

}